
import { FormEventType } from '@/ui-kit/components/form/enums';
import Typography from '@/ui-kit/components/typography';
import { TooltipMessage } from '@/ui-kit/components/tooltip/enum';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import { StyleFontWeightType } from '@/ui-kit/styles/enums';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import { SoldDataEvent } from '@/constants/AnalyticEvents';
import BaseForm from '../../shared/components/mixins/BaseForm';
import FormProps from '../../shared/components/mixins/FormProps';
import FormButtons from '../../shared/components/forms/buttons';
import SearchForm from '../../shared/components/forms/search';
import { SearchFormControlName } from '../../shared/components/forms/search/enums';
import TrackEvent from '../../shared/mixins/TrackEvent';
import { FormProperty } from '../../shared/components/enums';
import { ButtonsProperty } from '../../shared/components/forms/buttons/enums';
import IconHintTooltip from '@/components/shared/tooltips/icon-hint-tooltip';
import { IconHintTooltipProperty } from '@/components/shared/tooltips/icon-hint-tooltip/enum';
import Auth from '@/mixins/auth';

export default {
  name: 'SoldDataSearchForm',
  components: {
    IconHintTooltip,
    FormButtons,
    SearchForm,
    Typography,
  },
  mixins: [BaseForm, FormProps, TrackEvent, Auth],
  data() {
    return {
      IconHintTooltipProperty,
      TooltipMessage,
      TypographyType,
      TypographyProperty,
      StyleFontWeightType,
      ButtonFillType,
      FormEventType,
      FormProperty,
      ButtonsProperty,
      submitTrackEvent: SoldDataEvent.SearchApplyClick,
      trackEventByControlName: {
        [SearchFormControlName.Address]: SoldDataEvent.AddressSelect,
      },
    };
  },
  methods: {
    async handleSubmit() {
      const isAuthenticated = await this.checkAuthAndRedirect();

      this.formGroup.validate();

      if (this.formGroup.isValid && isAuthenticated) {
        this.$emit(FormEventType.Submit, this.formGroup.value);
        this.trackSubmit(this.formGroup.value[SearchFormControlName.Address]);
      }
    },
  },
};
